import { Modal, ModalCloseButton, ModalConfirmButton, ModalWidth } from '@dreryk/react-components';

import { documentTemplateActionTranslationKeys } from '../../../../translations';

import { DocumentTemplateActionForm } from './DocumentTemplateActionForm';

type DocumentTemplateActionModalProps = {
   readonly visitId: number;
   readonly onClose: VoidFunction;
};

export const DocumentTemplateActionModal = (props: DocumentTemplateActionModalProps): JSX.Element => {
   return (
      <Modal
         title={documentTemplateActionTranslationKeys.modal.title}
         onCloseRequest={props.onClose}
         width={ModalWidth.WIDE}
         testId={'documentTemplate'}
      >
         <DocumentTemplateActionForm visitId={props.visitId} onDocumentTemplateOpen={props.onClose}>
            <ModalConfirmButton label={documentTemplateActionTranslationKeys.modal.confirm} onClick={props.onClose} />
            <ModalCloseButton onClick={props.onClose} />
         </DocumentTemplateActionForm>
      </Modal>
   );
};
